import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router';

import { useVideoProjectCreation } from '@contexts/VideoProjectCreation.context';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 2rem;
	padding: 3rem 2rem;
	text-align: center;
`;

const SuccessTitle = styled.h2`
	color: ${({ theme }) => theme.colors.green};
	margin: 0;
	font-size: 2rem;
	font-weight: 600;
`;

const SuccessMessage = styled.p`
	color: rgba(255, 255, 255, 0.8);
	font-size: 1.125rem;
	margin: 0;
	max-width: 600px;
`;

const InfoPanel = styled.div`
	width: 100%;
	max-width: 600px;
	padding: 1.5rem;
	background: rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.1);
	border-radius: 0.375rem;
	border: 1px solid rgba(${({ theme }) => theme.colors.borderLightRgb}, 0.2);
`;

const InfoTitle = styled.h4`
	margin: 0 0 1rem 0;
	font-size: 1.125rem;
	font-weight: 600;
`;

const InfoRow = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0.5rem 0;

	&:not(:last-child) {
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	}
`;

const Label = styled.span`
	color: rgba(255, 255, 255, 0.7);
	font-size: 0.875rem;
`;

const Value = styled.span`
	color: #ffffff;
	font-weight: 500;
	font-size: 0.875rem;
	font-family: monospace;
`;

const ButtonGroup = styled.div`
	display: flex;
	gap: 1rem;
	margin-top: 1rem;
`;

const Finalize = () => {
	const navigate = useNavigate();
	const { projectUuid, videoUuid, jobUuid, isProcessing, retryProcessing } =
		useVideoProjectCreation();

	const handleRetryProcessing = async () => {
		const success = await retryProcessing();
		if (success) {
			navigate('/projects', { replace: true });
		}
	};

	return (
		<Container>
			<div>
				<SuccessTitle>Project Created</SuccessTitle>
				<SuccessMessage style={{ marginTop: '1rem' }}>
					Your video has been uploaded, but processing failed to start. Please retry.
				</SuccessMessage>
			</div>

			<InfoPanel>
				<InfoTitle>Information</InfoTitle>

				<InfoRow>
					<Label>Project ID:</Label>
					<Value>{projectUuid}</Value>
				</InfoRow>

				<InfoRow>
					<Label>Video ID:</Label>
					<Value>{videoUuid}</Value>
				</InfoRow>

				{jobUuid && (
					<InfoRow>
						<Label>Job ID:</Label>
						<Value>{jobUuid}</Value>
					</InfoRow>
				)}
			</InfoPanel>

			<ButtonGroup>
				<Button variant="warning" onClick={handleRetryProcessing} disabled={isProcessing}>
					{isProcessing ? 'Retrying...' : 'Retry Processing'}
				</Button>
			</ButtonGroup>
		</Container>
	);
};

export default Finalize;
